import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToasterUtilService } from '../../../util/toaster-util.service';
import { CadastroModalUtil } from '../../../util/modal/cadastro.modal.util';
import { UsuarioService } from '../../../service/usuario.service';
import { Select2OptionData } from 'ng2-select2';
import { UtilService } from '../../../util/util.service';

@Component({
  selector: 'app-importar-permissoes',
  templateUrl: './importar-permissoes.component.html',
  styleUrls: ['./importar-permissoes.component.scss'],
  providers: [UsuarioService]
})
export class ImportarPermissoesComponent implements OnInit {

  listaUsuarios: Array<Select2OptionData> = [];
  entityForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private toasterUtil: ToasterUtilService,
    private cadastroModalUtil: CadastroModalUtil,
    private usuarioService: UsuarioService
  ) {

  }
  ngOnInit() {

    this.criarFormGroup();

    this.usuarioService.selectOptionData().then((retorno : Array<Select2OptionData>) => {
                                            for (let index = 0; index < retorno.length; index++) {
                                              this.listaUsuarios.push(retorno[index]);
                                            }
                                          }).catch((error) => this.toasterUtil.erro(error));
  }

  criarFormGroup(){
    this.entityForm = this.fb.group({
      usuario: [[]],
    });
  }

  onCancelar(event){
    this.cadastroModalUtil.closeModal();
  }

  onImportar(event){
    if(UtilService.empty(this.entityForm.controls['usuario'].value)){
      this.toasterUtil.alerta('Usuário não foi informado para a importação da permissão.')
      return;
    }

    this.cadastroModalUtil.modelSelect = this.entityForm.controls['usuario'].value;
    this.cadastroModalUtil.closeModal();

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/componentes/importar-permissoes/importar-permissoes.component.ts